import { notification } from 'antd'

interface ResponseNotification {
  message: string
  description: string
  type: 'success' | 'warn' | 'error' | 'info'
}

export const responseNotification = (
  notificationOptions: ResponseNotification
): any => {
  const { description, message, type } = notificationOptions

  notification[type]({
    message,
    description
  })
}
